<template>
  <div class="Search-page">
    <div><my-Title :title="title" :isCancel="true" @cancel="cancel" /></div>
    <div class="Search-box">
      <div class="Search-input-home">
        <my-SearchInput
          :funnel="SearchFunnel"
          :placeholder="placeholder"
          :typeof="true"
          @Search="Search"
        />
      </div>
    </div>
    <div class="historical-record" v-if="searchHistory.length > 0">
      <div class="historical-title">
        <div class="History-text">Search History</div>
        <div class="clean">
          <img @click="ClearRecords" src="@/assets/mybox/search/clean.png" />
        </div>
      </div>
      <div class="historical-list">
        <div
          class="historical-li"
          v-for="(itx, idx) in searchHistory"
          @click="searchGoods(itx)"
          :key="idx"
        >
          {{ itx }}
        </div>
      </div>
    </div>
    <div class="box-list">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "Search" },
    name: {
      type: String,
      default: "",
    }, //盒子类型得搜索到的内容
    placeholder: {
      type: String,
      default: "Search",
    },
  },
  data() {
    return {
      goodsText: "",
      searchHistory: [], //历史记录
      isModules: "", //展示的组件的名称
      SearchFunnel: false, //默认不享受漏斗
    };
  },
  created() {
    //历史记录获取
    const history = this.$ls.get(`${this.name}-history`);
    this.searchHistory = history || [];
    //是否显示搜索漏斗
    this.SearchFunnel = this.$store.state.staking.searchFunnel.includes(
      this.name
    );
    console.log("历史记录", this.searchHistory);
  },
  methods: {
    //搜索
    Search(val) {
      if (val == "") {
        this.$toast.fail("请输入内容");
        return;
      }
      // 使用Set进行去重，避免JSON的序列化和反序列化
      let set = new Set(this.searchHistory);
      set.add(val);
      // 如果长度超过10，则删除最旧的记录
      if (set.size > 10) {
        // Set没有直接支持删除特定索引元素的方法，转换为Array处理
        let arr = Array.from(set);
        arr.shift(); // 删除第一个元素
        set = new Set(arr); // 重新转换为Set
      }
      this.searchHistory = Array.from(set); // 将Set转换为Array并赋值
      this.$ls.set(`${this.name}-history`, this.searchHistory);
      this.$emit("search", val);
      this.$emit("cancel");
    },
    //清空历史记录
    ClearRecords() {
      this.searchHistory = [];
      this.$ls.remove(`${this.name}-history`);
    },
    //点击历史记录搜索
    searchGoods(val) {
      this.$emit("search", val);
      this.$emit("cancel");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.Search-page {
  height: 100%;
  padding: 0.4rem;
  .Search-box {
    margin: 0.4rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .Search-input-home {
      width: 100%;
    }
  }
  .historical-record {
    margin: 5% 0;
    .historical-title {
      font-size: 0.32rem;
      margin: 0.3rem 0;
      display: flex;
      justify-content: space-between;
      .History-text {
      }
      .clean {
      }
    }
    .historical-list {
      font-size: 0.24rem;
      color: #585858;
      display: flex;
      flex-wrap: wrap;
      .historical-li {
        background: #f3f5f7;
        border-radius: 6px;
        width: fit-content;
        max-width: 27%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 0.5rem;
        line-height: 0.5rem;
        padding: 0 0.2rem;
        margin: 0.2rem;
      }
    }
    .searchHistory-span {
      font-size: 0.34rem;
      text-align: left;
      margin: 0.2rem 0;
    }
  }
}
</style>
